module.exports = __webpack_public_path__ + "img/chinesecompany139.e2744a29.png";